import type { RedisClient } from '@devhacker/shared/plugins/redis/redisClient';
import { FETCH_WIDGETS_REDIS_KEY } from '~/constants/widgets';

export async function getWidgetsFromRedis($redisClient: RedisClient | null, keys: string[]) {
  const hit: Record<string, unknown> = {};
  const miss: string[] = [];

  for (const key of keys) {
    const widgetsCache = await $redisClient?.get(`${FETCH_WIDGETS_REDIS_KEY}[${key}]`);
    if (widgetsCache) hit[key] = widgetsCache;
    else miss.push(key);
  }

  return { hit, miss };
}

export async function saveWidgetsToRedis(
  $redisClient: RedisClient | null,
  widgets: Record<string, unknown>,
) {
  for (const key in widgets) {
    const baseTtl = 60 * 50; // 50 min
    // чистим кеш поочередно, а не одновременно, чтобы избежать резкой нагрузки на бек
    const variableTtl = Math.round(Math.random() * 60 * 10); // random between 0 and 10 min
    await $redisClient?.set(
      `${FETCH_WIDGETS_REDIS_KEY}[${key}]`,
      widgets[key],
      baseTtl + variableTtl,
    );
  }
}
